import styled from '@emotion/styled'
import { Expanded, TriggerComponent } from '../types'
import { colors } from 'parameters/ui'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import Arrow from './arrow.svg'
import { ifHovered } from '../../../styles'
import { ColorMods } from 'components/styles/primitives/modifiers/text/colorMods'
import { TextMods } from 'components/styles/primitives/modifiers/text/textMods'
import { Center } from 'components/layout/primitives'
import { PaddingMods } from '../../../styles/primitives/modifiers/shape/padding'
import { SpaceProperties } from '../../../styles/definitions/size/typographyScale'
import { ModifiableDiv } from '../../../styles/primitives/core/mods'

interface TriggerSettings {
	collapsedText: string
	expandedText: string
}
export const TriggerFactory: (settings?: TriggerSettings) => TriggerComponent =
	(settings = { expandedText: 'Show Less', collapsedText: 'Show More' }) =>
	({ expanded, disabled, onClick }) => {
		return (
			<Center>
				<Container onClick={onClick} disabled={disabled}>
					<ModifiableDiv modifiers={[TextMods.Centered]}>
						{expanded ? settings.expandedText : settings.collapsedText}
						<Icon expanded={expanded}>
							<InlineSvg src={Arrow} />
						</Icon>
					</ModifiableDiv>
				</Container>
			</Center>
		)
	}

export const DefaultTrigger = TriggerFactory()

const Container = styled.fieldset`
	${PaddingMods.All(SpaceProperties.Small)}
	color: ${colors.primaryPurple1};
	background: transparent;
	cursor: pointer;
	${ifHovered(ColorMods({ background: colors.secondaryPurple2 }))}
	:disabled {
		color: ${colors.secondaryLightGrey1};
		background-color: transparent;
	}
`

const Icon = styled.div<Expanded>`
	display: inline-block;
	width: 10px;
	fill: currentColor;
	margin-left: 5px;
	transform: ${({ expanded }) => (expanded ? 'scaleY(-1)' : 'scaleY(1)')};
	transition: transform 0.3s;
`
